export type ToastType = 'success' | 'warning' | 'error' | 'info';

export class Toast {
	id!: string;
	message?: string;
	type?: ToastType;
	duration?: number;
	removing?: boolean;
	closeButton?: boolean;
	autoClose?: boolean;
	unique?: boolean;

	static create(data: Partial<Toast>): Toast {
		return {
			closeButton: true,
			autoClose: true,
			duration: 4000,
			removing: false,
			unique: false,
			...data,
		} as Toast;
	}
}
